import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  containerFilter: {
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingVertical: 15,
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxHeight: '80%',
  },
  containerButton: {
    paddingHorizontal: 45,
    marginTop: 20,
    alignItems: 'center',
  },
});
